import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-mark-logo",
    templateUrl: "./mark-logo.component.html",
    styleUrls: ["./mark-logo.component.scss"],
    standalone: false
})
export class FUIMarkLogoComponent {
    @Input() type: "chewzie" | "fedelta" = "fedelta";

    constructor() {}
}
